import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useHandleProductDone = (product_state:string)=>{
    const navigate = useNavigate();
    
    useEffect(()=>{
        if(product_state === "RADICADO") navigate("/mis-creditos") 
    },[product_state, navigate])
}